export default __webpack_public_path__ + "static/media/oxtail.6bf702ab.png";